module.exports = __webpack_public_path__ + "img/add.bf36a55a.png";